module.exports = __webpack_public_path__ + "static/media/yeah6.d4f11098.wav";